// extracted by mini-css-extract-plugin
export default {"background":"Navigation_background__rwNIj"};